/**
 * @param {any[]} a
 * @param {number} size
 */
function getChunks(a, size) {
	return Array.from(new Array(Math.ceil(a.length / size)), (_, i) => a.slice(i * size, i * size + size));
}

export default getChunks;
